import { useUserEventLogger } from '@repo/tracking-service';
import { Accordion, useAccordionContext } from '@zenterprise-inc/ui';
import cn from 'clsx';
import { useEffect, useRef, useState } from 'react';

import s from '@/components/landing/Landing.module.scss';
import { FaqItem } from '@/lib/constants/home';

const FaqAccordion = ({ item, className }: { item: FaqItem; className?: string }) => {
  const accordionRef = useRef<HTMLDivElement>(null);

  return (
    <Accordion.Accordion ref={accordionRef} className={`cursor-pointer ${className}`}>
      <AccordionContent title={item.title} contents={item.contents} clickEvent={item.clickEvent} />
    </Accordion.Accordion>
  );
};

export default FaqAccordion;

const AccordionContent = ({ contents, clickEvent, title }: FaqItem) => {
  const { onClick, isExpanded } = useAccordionContext();
  const { sendClickEvent } = useUserEventLogger();
  const [onFocus, setOnFocus] = useState(false);
  const titleRef = useRef<HTMLDivElement>(null);

  const checkFocus = (event: globalThis.MouseEvent) => {
    if (!titleRef.current) return;
    setOnFocus(titleRef.current.contains(event.target as HTMLElement));
  };

  const toggleAccordion = () => {
    if (clickEvent && !isExpanded) {
      sendClickEvent(clickEvent);
    }
    onClick();
  };

  useEffect(() => {
    document.addEventListener('click', checkFocus);

    return () => {
      document.removeEventListener('click', checkFocus);
    };
  }, []);

  return (
    <>
      <div
        ref={titleRef}
        className={cn('paragraph-3 flex w-full items-center justify-between gap-10 py-[1em] font-semibold text-black sm:py-9', {
          'text-violet-600': onFocus
        })}
        onClick={toggleAccordion}
      >
        <div className={'flex-1'}>{title}</div>
        <Accordion.AccordionIcon size={30} />
      </div>
      <Accordion.AccordionPanel onClick={toggleAccordion}>
        <div className={s.accordion_contents}>{contents}</div>
      </Accordion.AccordionPanel>
    </>
  );
};
